import { render, staticRenderFns } from "./comStep2.vue?vue&type=template&id=30f58b3e&scoped=true&"
import script from "./comStep2.vue?vue&type=script&lang=js&"
export * from "./comStep2.vue?vue&type=script&lang=js&"
import style0 from "./comStep2.vue?vue&type=style&index=0&id=30f58b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f58b3e",
  null
  
)

export default component.exports